import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  paper: {
    maxWidth: theme.spacing(90)
  },
  header: {
    padding: theme.spacing(3, 3, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2)
  },
  eyebrow: {
    display: 'block',
    color: theme.palette.text.primary,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    fontWeight: 500,
    marginBottom: theme.spacing(0.5)
  },
  title: {
    color: theme.palette.text.secondary,
    fontWeight: 500
  },
  subtitle: {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(0.5)
  },
  content: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '.MuiDialogTitle-root + &': {
      paddingTop: theme.spacing(3)
    }
  },
  summary: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr 1fr'
    }
  },
  summaryCard: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#F7F8FA'
  },
  summaryLabel: {
    color: theme.palette.text.primary,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontWeight: 500,
    display: 'block',
    marginBottom: theme.spacing(0.5)
  },
  summaryValue: {
    color: theme.palette.text.secondary,
    fontWeight: 500
  },
  reasonCard: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.badge.info.bg
  },
  reasonLabel: {
    color: theme.palette.badge.info.text,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontWeight: 500,
    display: 'block',
    marginBottom: theme.spacing(0.5)
  },
  reasonText: {
    color: theme.palette.badge.info.text
  },
  changesCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius
  },
  changesHeader: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    flexWrap: 'wrap'
  },
  changesTitle: {
    color: theme.palette.text.primary,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontWeight: 500
  },
  financialImpactBadge: {
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.badge.warning.bg,
    color: theme.palette.badge.warning.text,
    fontWeight: 500,
    fontSize: '0.75rem',
    whiteSpace: 'nowrap'
  },
  rows: {
    borderTop: `1px solid ${theme.palette.divider}`
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    flexWrap: 'wrap',
    '& + &': {
      borderTop: `1px solid ${theme.palette.divider}`
    }
  },
  rowLabel: {
    color: theme.palette.text.secondary,
    fontWeight: 500
  },
  rowValues: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap'
  },
  valueBox: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
    minWidth: theme.spacing(14)
  },
  oldValueBox: {
    backgroundColor: '#F7F8FA'
  },
  newValueBox: {
    backgroundColor: theme.palette.badge.success.bg
  },
  valueCaption: {
    color: theme.palette.text.primary,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: theme.spacing(0.25)
  },
  oldValue: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    textDecoration: 'line-through',
    textDecorationColor: theme.palette.badge.error.text
  },
  newValue: {
    color: theme.palette.text.secondary,
    fontWeight: 600
  },
  arrowCircle: {
    flex: 'none',
    width: theme.spacing(5),
    height: theme.spacing(5),
    borderRadius: '50%',
    border: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary
  },
  operationalReading: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.badge.neutral.bg,
    color: theme.palette.badge.neutral.text
  },
  operationalReadingIcon: {
    flex: 'none',
    marginTop: theme.spacing(0.25)
  },
  operationalReadingTitle: {
    fontWeight: 500,
    display: 'block',
    marginBottom: theme.spacing(0.5)
  },
  actions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    flexWrap: 'wrap'
  },
  registered: {
    color: theme.palette.text.primary
  }
}));
